import { LoggerCategoryEnum, LoggerLevelEnum, ILogQueue } from './LoggerCore.types';

export function getInitialLogQueue() {
    const data: ILogQueue = {
        [LoggerCategoryEnum.default]: [],
        [LoggerCategoryEnum.analytics]: [],
        [LoggerCategoryEnum.diagnostic]: [],
        [LoggerCategoryEnum.api]: [],
        [LoggerCategoryEnum.ui]: []
    };
    return data;
}

export const logLevels = [LoggerLevelEnum.log, LoggerLevelEnum.info, LoggerLevelEnum.debug, LoggerLevelEnum.warn, LoggerLevelEnum.error];
